import { render, staticRenderFns } from "./InputPontoReferencia.vue?vue&type=template&id=1d80c008"
import script from "./InputPontoReferencia.vue?vue&type=script&lang=js"
export * from "./InputPontoReferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports